<template>
  <v-skeleton-loader
    :loading="$store.getters['cargoTypes/loading']"
    type="list-item-two-line"
  >
    <v-select
      v-model="selected"
      :dense="dense"
      :menu-props="{maxHeight: 500}"
      :disabled="disabled || $store.state.auth.user.cargoTypeID != null"
      :items="items"
      item-text="name"
      item-value="id"
      label="Тип груза"
      :item-color="$store.getters['settings/dark'] ? 'white' : 'black'"
      :error-messages="errorMessages"
      @input="onSelectedChanged"
      @blur="onBlur"
    />
  </v-skeleton-loader>
</template>

<script>
export default {
  props: ['value', 'disabled', 'canAny', 'errorMessages', 'dense', 'anyLabel'],

  data: () => ({
    selected: null
  }),

  computed: {
    items: function () {
      return this.canAny
        ? [...[{ id: 0, name: this.anyLabel ? this.anyLabel : '[ Любой ]' }], ...this.$store.getters['cargoTypes/items']]
        : this.$store.getters['cargoTypes/items']
    }
  },

  watch: {
    value: function (val) {
      // для клиентов выбор предустановлен
      let newValue = this.$store.state.auth.user.cargoTypeID ?? val
      // если вдруг значение не корректно, то ставим первый попавшийся
      // такое возможно, если в localStore сохранён cargoTypeID = 4, а клиенту доступен только 1
      if (!this.items.some(x => x.id === newValue)) {
        newValue = this.items[0].id
      }
      this.selected = newValue
      if (val !== newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  created () {
    // для клиентов выбор предустановлен
    let initValue = this.$store.state.auth.user.cargoTypeID ?? this.value
    // если вдруг значение не корректно, то ставим первый попавшийся
    // такое возможно, если в localStore сохранён cargoTypeID = 4, а клиенту доступен только 1
    if (!this.items.some(x => x.id === initValue)) {
      initValue = this.items[0].id
    }
    this.selected = initValue
    if (this.value !== initValue) {
      this.$emit('input', initValue)
    }
  },

  methods: {
    onSelectedChanged (val) {
      this.$emit('input', val)
    },
    onBlur (val) {
      this.$emit('blur', val)
    }
  }
}
</script>
